export default abstract class HTTPRequest {
    private headers: Record<string, unknown>;
    private body?: string;
    private method: string = "GET";
    private url: string;
    private queryParams: Record<string, string> = {};

    constructor() {

    }
    public getHeader(name: string): unknown {
        return this.headers[name];
    }
    public addHeader(name: string, value: unknown): HTTPRequest {
        if (!name) {
            throw new Error("Header name cannot be empty");
        }
        if (this.hasHeader(name)) {
            throw new Error(`Header ${name} already exists`);
        }
        this.headers[name] = value;
        return this;
    }

    public removeHeader(name: string): HTTPRequest {
        if (!this.hasHeader(name)) {
            throw new Error(`Header ${name} does not exist`);
        }
        delete this.headers[name];
        return this;
    }

    public hasHeader(name: string): boolean {
        return name in this.headers;
    }

    public getHeaders(): Record<string, unknown> {
        return this.headers;
    }

    public setHeaders(headers: Record<string, unknown>): HTTPRequest {
        this.headers = headers;
        return this;
    }

    public getBody(): string | undefined {
        return this.body;
    }
    public setBody(body: string): HTTPRequest {
        this.body = body;
        return this;
    }
    public getMethod(): string {
        return this.method;
    }
    public setMethod(method: string): HTTPRequest {
        this.method = method.toUpperCase();
        return this;
    }
    public getUrl(): string {
        return this.url;
    }
    public setUrl(url: string): HTTPRequest {
        this.url = url;
        return this;
    }

    public getQueryParams(): Record<string, string> {
        return this.queryParams;
    }
    public setQueryParams(queryParams: Record<string, string>): HTTPRequest {
        this.queryParams = queryParams;
        return this;
    }
    public addQueryParam(name: string, value: string): HTTPRequest {
        if (!name) {
            throw new Error("Query parameter name cannot be empty");
        }
        this.queryParams[name] = value;
        return this;
    }
    public removeQueryParam(name: string): HTTPRequest {
        if (!this.hasQueryParam(name)) {
            throw new Error(`Query parameter ${name} does not exist`);
        }
        delete this.queryParams[name];
        return this;
    }
    public hasQueryParam(name: string): boolean {
        return name in this.queryParams;
    }

    private buildUrlWithQueryParams(): string {
        const queryString = new URLSearchParams(this.queryParams).toString();
        return queryString ? `${this.url}?${queryString}` : this.url;
    }

    private transformHeadersToFetchFormat(): Record<string, string> {
        const transformedHeaders: Record<string, string> = {};
        for (const [key, value] of Object.entries(this.headers)) {
            if (typeof value !== 'string' && typeof value !== 'number') {
                throw new Error(`Header value for ${key} must be a string or number`);
            }
            transformedHeaders[key] = String(value);
        }
        return transformedHeaders;
    }

    public send(): Promise<Response> {
        const url = this.buildUrlWithQueryParams();
        const options: RequestInit = {
            method: this.method,
            headers: this.transformHeadersToFetchFormat(),
        };

        /*if (this.body) {
            options.body = this.body;
        }*/

        return fetch(url, options)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response;
            })
            .catch(error => {
                console.error("Error during HTTP request:", error);
                throw error;
            });
    }
}    